<template>
  <div>
		<button type="button" class="btn btn-primary" @click="getMailing">Обновить шаблон письма</button>
		<button type="button" class="btn btn-success" @click="saveEvent">Сохранить</button>
		<br><br>
    <tinymce
			id="1"
			:other_options="tinyOptions"
			v-model="tableData"
    >
		</tinymce>
	</div>
</template>
<script>
export default {
	data () {
		return {
			ids: 'sdfg',
			tableData: '',
			tinyOptions: {
				height: 3000,
				plugins: [
					'advlist autolink autosave link image lists charmap print hr',
					'searchreplace wordcount visualblocks visualchars code insertdatetime media nonbreaking',
					'save table contextmenu directionality emoticons template paste fullpage textcolor colorpicker'
				]
			}
		}
	},
	props: {
		id: {
			type: Number,
			required: true
		}
	},
	created () {
		this.getMailing()
	},
	methods: {
		getMailing () {
			this.$store.commit('CALL_API_ON')
			this.readyData = false
			this.$http.get(this.$store.state.apiURL + '/v1/mailing/templates/' + this.id, {}, {
			}).then(function (response) {
				this.tableData = response.body
				this.readyData = true
				console.log(typeof this.tableData)
				this.$store.commit('CALL_API_OFF')
				this.readyData = true
			}, function (response) {
			})
		},
		saveEvent: function () {
			this.$store.commit('CALL_API_ON')
			this.$http.put(this.$store.state.apiURL + '/v1/mailing/templates/' + this.id, {text: this.tableData}, {
				headers: {
					'content-type': 'application/json'
				}
			}).then(function (response) {
				this.$store.commit('CALL_API_OFF')
			}, function (response) {
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/mailing/Templates.vue